// @flow
import { useList } from 'effector-react'
import { $widgets } from './model/store'
import { WIDGETS_COMPONENTS } from './widgets-map'

export const Builder = () => {
  return (
    <>
      {useList($widgets, (widget, index) => {
        if (widget.name in WIDGETS_COMPONENTS) {
          const ExternalComponent = WIDGETS_COMPONENTS[widget.name]

          return <ExternalComponent key={widget.name} index={index} widget={widget} />
        }

        return null
      })}
    </>
  )
}
